import { defineMessages } from "react-intl"

export const TAX_SETTINGS_MESSAGES = defineMessages({
    dynamicTax: {
        id: "settings.taxes.tax_settings.dynamic_tax",
        defaultMessage: "Dynamic Tax"
    },
    description: {
        id: "settings.taxes.tax_settings.description",
        defaultMessage: "Automatically find tax rates based on contact information"
    },
})


// WEBPACK FOOTER //
// ./src/utils/tax/messages.ts